<template>
  <Layout :show-header="true">
    <template #header>
      <div>动平衡异常检测</div>
    </template>
    <div class="row q-col-gutter-x-md full-height">
      <div class="col-5 col-xs-12 col-sm-5 column justify-around">
        <q-card flat bordered class="full-height column">
          <q-card-section class="q-pb-none">
            <div class="text-h6">动平衡异常检测显示</div>
          </q-card-section>

          <q-card-section
            class="column justify-center items-center q-pb-none car-img"
            style="flex: 1"
          >
            <!-- car -->
            <q-img
              :src="'/底盘透明_纵向_不带轮胎.png'"
              :style="{
                height: IMG_HEIGHT + 'px',
                width: IMG_WIDTH + 'px',
              }"
              spinner-color="white"
              fit="contain"
            >
              <!-- 轮胎 -->
              <q-img
                v-for="(tire, index) in tires"
                :key="tire.name"
                :style="{
                  position: 'absolute',
                  left: tire.position.left + 'px',
                  top: tire.position.top + 'px',
                  right: tire.position.right + 'px',
                  bottom: tire.position.bottom + 'px',
                  width: TIRES_WIDTH + 'px',
                  height: TIRES_HEIGHT + 'px',
                }"
                :src="tire.src"
                alt="tire"
              >
                <div
                  class="absolute-full"
                  :style="`  background-color:${
                    tire.error ? 'rgba(255, 0, 0, 0.5)' : 'rgba(0, 255, 0, 0.5)'
                  }  ;
                        border-radius: 8px;`"
                ></div>
                <div
                  :style="{
                    position: 'absolute',
                    left: tire.gaugePosition.left + 'px',
                    top: tire.gaugePosition.top + 'px',
                    right: tire.gaugePosition.right + 'px',
                    bottom: tire.gaugePosition.bottom + 'px',
                    zIndex: 9,
                  }"
                  class="absolute"
                >
                  <Gauge
                    :value="tire.value"
                    :max="50"
                    :position="tire.gaugeLabelPosition  as any"
                  />
                </div>
              </q-img>
            </q-img>
          </q-card-section>
          <q-card-actions
            class="row justify-between q-pa-lg"
            style="padding-top: 0px"
          >
            <q-btn
              class="q-mr-md"
              size="lg"
              round
              color="teal"
              glossy
              icon="refresh"
              @click="handleReset"
            />
            <q-btn
              size="lg"
              round
              :color="playStatus === 'play' ? 'red' : 'green-6'"
              glossy
              :icon="playStatus === 'play' ? 'pause' : 'play_arrow'"
              @click="handlePlayStatusChange"
            />
          </q-card-actions>
        </q-card>
      </div>
      <div class="col-7 col-xs-12 col-sm-7">
        <q-card flat bordered class="column full-height">
          <q-card-section class="row justify-between items-center q-pb-none">
            <div class="text-h6">悬架高度随速频段幅值</div>
          </q-card-section>

          <q-card-section class="overflow-hidden" style="flex: 1">
            <!-- car -->
            <div
              class="column full-height q-col-gutter-y-md overflow-hidden"
              style="border-radius: 20px; margin-bottom: -26px"
            >
              <div class="col-6">
                <div
                  class="overflow-hidden full-height"
                  style="border-radius: 20px"
                >
                  <Charts :options="optionsF" />
                </div>
              </div>
              <div class="col-6">
                <div
                  class="overflow-hidden full-height"
                  style="border-radius: 20px"
                >
                  <Charts :options="optionsR" />
                </div>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import {
  decreasingSequence,
  getChartsDefaultOptions,
  getDefaultSeriesData,
  getMax,
  PlayStatus,
} from "./helper/dur";
import Layout from "./components/Layout.vue";
import Charts from "@/components/Charts";
import Gauge from "@/components/Gauge";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import {
  generateMockDURNofifyData,
  NOTIFY,
} from "@/services/domainControl/dur";
import { signalTransformNum2Bool } from "./helper";
import { useQuasar } from "quasar";
import { useDomainControlStore } from "@/stores/domainControl";
const $q = useQuasar();
const domainControlStore = useDomainControlStore();

const IMG_HEIGHT = 550;
const CAR_HEIGHT = 1810;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 813 * IMG_RATE;
const TIRES_TOP = 245 * IMG_RATE;
const TIRES_BOTTOM = 367 * IMG_RATE;
const TIRES_HEIGHT = 250* IMG_RATE;
const TIRES_WIDTH = 96 * IMG_RATE;
const TIRES_RIGHT = 76 * IMG_RATE;
const TIRES_LEFT = 90 * IMG_RATE;

const tires = ref([
  {
    name: "左前",
    value: 0,
    error: false,
    src: "/轮胎左.png", // 轮胎图片路径
    position: { left: TIRES_LEFT, top: TIRES_TOP }, // 轮胎在车图片中的位置
    gaugePosition: { left: -80, top: -50 },
    gaugeLabelPosition: "left",
  },
  {
    name: "右前",
    value: 0,
    error: false,
    src: "/轮胎左.png",
    position: { right: TIRES_RIGHT, top: TIRES_TOP },
    gaugePosition: { right: 0, top: -50 },
    gaugeLabelPosition: "right",
  },
  {
    name: "右后",
    value: 0,
    error: false,
    src: "/轮胎左.png",
    position: { right: TIRES_LEFT, bottom: TIRES_BOTTOM },
    gaugePosition: { right: 0, bottom: 100 },
    gaugeLabelPosition: "right",
  },
  {
    name: "左后",
    value: 0,
    error: false,
    src: "/轮胎左.png",
    position: { left: TIRES_RIGHT, bottom: TIRES_BOTTOM },
    size: { width: 50, height: 50 },
    gaugePosition: { left: -80, bottom: 100 },
    gaugeLabelPosition: "left",
  },
]);

const seriesData = ref(getDefaultSeriesData());
const optionsF = ref(getChartsDefaultOptions(0));
const optionsR = ref(getChartsDefaultOptions(1));
const playStatus = ref<PlayStatus>("play");

watch(
  () => seriesData.value,
  (newValue) => {
    // console.log("[BOWEN_LOG] 🚀 ~~ newValue:", newValue);
    const {
      UIRx_SuspHgtAmp_FL,
      UIRx_SuspHgtAmp_FR,
      UIRx_SuspHgtAmp_RL,
      UIRx_SuspHgtAmp_RR,
    } = newValue;

    //  UIRx_SuspHgtAmp_FL && UIRx_SuspHgtAmp_FR  中的最大值
    const maxF = getMax(UIRx_SuspHgtAmp_FL as any, UIRx_SuspHgtAmp_FR as any);
    (optionsF.value.yAxis as any).max = maxF;

    const maxR = getMax(UIRx_SuspHgtAmp_RL as any, UIRx_SuspHgtAmp_RR as any);
    (optionsR.value.yAxis as any).max = maxR;

    (optionsF.value.series as any)[0].data = UIRx_SuspHgtAmp_FL;
    (optionsF.value.series as any)[1].data = UIRx_SuspHgtAmp_FR;

    (optionsR.value.series as any)[0].data = UIRx_SuspHgtAmp_RL;
    (optionsR.value.series as any)[1].data = UIRx_SuspHgtAmp_RR;
  }
);

const handleNotify = (data: DomianControl.DURNotifyData) => {
  if (playStatus.value === "play") parseSeriesData(data);
  parseTiresData(data);
};

const parseSeriesData = (data: DomianControl.DURNotifyData) => {
  const timestamp = Date.now();
  const res = [
    "UIRx_SuspHgtAmp_FL",
    "UIRx_SuspHgtAmp_FR",
    "UIRx_SuspHgtAmp_RL",
    "UIRx_SuspHgtAmp_RR",
  ].reduce((per, key) => {
    const value = data[key];
    const curList = seriesData.value[key] || [];
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push([timestamp, value]);
    per[key] = curList;
    return per;
  }, {} as DomianControl.DURSeriesData);
  seriesData.value = res;
};
const parseTiresData = (data: DomianControl.DURNotifyData) => {
  tires.value[0].error = signalTransformNum2Bool(data.UIRx_DUFlg_FL);
  tires.value[1].error = signalTransformNum2Bool(data.UIRx_DUFlg_FR);
  tires.value[2].error = signalTransformNum2Bool(data.UIRx_DUFlg_RR);
  tires.value[3].error = signalTransformNum2Bool(data.UIRx_DUFlg_RL);
  tires.value[0].value = data.UIRx_DUIdx_FL;
  tires.value[1].value = data.UIRx_DUIdx_FR;
  tires.value[2].value = data.UIRx_DUIdx_RR;
  tires.value[3].value = data.UIRx_DUIdx_RL;
};
const parseOutputValue = (value: DomianControl.OutputValue) => {
  console.log("[BOWEN_LOG] 🚀 ~~ parseOutputValue ~~ value:", value);
};

const handlePlayStatusChange = async () => {
  const value = playStatus.value === "play" ? "pause" : "play";
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
  }
  playStatus.value = value;
};

const handleReset = () => {
  domainControlStore.writeOutputValue({
    UITx_DURrst: 1,
  });
  setTimeout(() => {
    domainControlStore.writeOutputValue({
      UITx_DURrst: 0,
    });
  }, 500);
};

const { startNotifications, stopNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

// onMounted(() => {
//   setInterval(() => {
//     handleNotify(generateMockDURNofifyData() as any);
//   }, 50);
// });
</script>

<style scoped lang="scss">
.car-img {
  .q-img__content > div {
    background-color: transparent;
    padding: 0px;
  }
}
.q-img {
  overflow: unset;
}
</style>
